import { createContext, useContext } from "react";

type CrudErrorHandler = (error: any) => void;

/**
 * Provides the crud modal's error handler to its form fields, so it no longer
 * has to be threaded through every field as a prop. Provided by
 * GenericCrudTableModal; consumed by the wrapper field (and later the
 * CrudField components).
 */
export const CrudErrorContext = createContext<CrudErrorHandler | null>(null);

/**
 * Error handler for crud form fields: context first, then the deprecated
 * handleError prop as fallback, then a no-op.
 */
export const useCrudFieldError = (
  fallback?: CrudErrorHandler,
): CrudErrorHandler => {
  const fromContext = useContext(CrudErrorContext);
  return fromContext ?? fallback ?? (() => undefined);
};
